import { CalendarOutlined, SwapOutlined } from "@ant-design/icons";
import { faPlayCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faDotCircle,
  faFileImport,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Image } from "antd";
import dayjs from "dayjs";

export const reelsTabItems = [
  {
    key: "2",
    label: "Untagged",
  },
  {
    key: "1",
    label: "Tagged",
  },
];

export const categories = [
  "none",
  "Cloths",
  "Bags",
  "Shoes",
  "Watches",
  "Devices",
];
export const mappingCategories = [
  "Products",
  "Form",
  "Collection/Category",
  "Quiz",
  "Poll",
  "Custom Link",
];

export const FilterItems = [
  {
    label: "Date Range",
    key: "range",
    icon: <CalendarOutlined />,
  },
  {
    label: "State",
    key: "state",
    icon: <SwapOutlined />,
  },
  {
    label: "Sort By",
    key: "sort",
    icon: <FontAwesomeIcon icon={faSort} />,
  },
  {
    label: "Imports",
    key: "imports",
    icon: <FontAwesomeIcon icon={faFileImport} />,
  },
];

export const FilterItemsReels = [
  {
    label: "Date Range",
    key: "range",
    icon: <CalendarOutlined />,
  },
  {
    label: "State",
    key: "state",
    icon: <FontAwesomeIcon icon={faDotCircle} />,
  },
  {
    label: "Action",
    key: "mapping",
    icon: <FontAwesomeIcon icon={faPlayCircle} />,
  },
  {
    label: "Sort",
    key: "sort",
    icon: <FontAwesomeIcon icon={faSort} />,
  },
];

export const rangePresets = [
  {
    label: "All",
    value: null,
  },
  {
    label: "Today",
    value: [dayjs(), dayjs()],
  },
  {
    label: "Yesterday",
    value: [dayjs().subtract(1, "d"), dayjs().subtract(1, "d")],
  },
  {
    label: "Last 7 Days",
    value: [dayjs().add(-7, "d"), dayjs()],
  },
  {
    label: "Last 14 Days",
    value: [dayjs().add(-14, "d"), dayjs()],
  },
  {
    label: "Last 30 Days",
    value: [dayjs().add(-30, "d"), dayjs()],
  },
  {
    label: "Last 60 Days",
    value: [dayjs().add(-60, "d"), dayjs()],
  },
];

export const rangePresetsWithoutAll = [
  {
    label: "Today",
    value: [dayjs(), dayjs()],
  },
  {
    label: "Yesterday",
    value: [dayjs().subtract(1, "d"), dayjs().subtract(1, "d")],
  },
  {
    label: "Last 7 Days",
    value: [dayjs().add(-7, "d"), dayjs()],
  },
  {
    label: "Last 14 Days",
    value: [dayjs().add(-14, "d"), dayjs()],
  },
  {
    label: "Last 30 Days",
    value: [dayjs().add(-30, "d"), dayjs()],
  },
  {
    label: "Last 60 Days",
    value: [dayjs().add(-60, "d"), dayjs()],
  },
];

export function generateUniqueName(number) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let uniqueName = "";
  const currentNumber = number ? number : 3;

  for (let i = 0; i < currentNumber; i++) {
    let segment = "";
    for (let j = 0; j < 4; j++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      segment += characters[randomIndex];
    }
    uniqueName += segment;
    if (i < 2 && !number) uniqueName += "-";
  }

  return uniqueName;
}

export const options = [
  {
    value: "100",
    label: "100",
  },
  {
    value: "200",
    label: "200",
  },
  {
    value: "300",
    label: "300",
  },
  {
    value: "400",
    label: "400",
  },
  {
    value: "500",
    label: "500",
  },
  {
    value: "600",
    label: "600",
  },
  {
    value: "700",
    label: "700",
  },
  {
    value: "800",
    label: "800",
  },
  {
    value: "900",
    label: "900",
  },
];

const ImageContainer = ({ url }) => {
  return <Avatar src={url} style={{ height: "35px", width: "35px" }} />;
};

const ImageContainerVudio = ({ url }) => {
  return (
    <Avatar
      src={url}
      shape={"square"}
      style={{ height: "35px", width: "35px" }}
    />
  );
};

export const backgorundImagesVideoCorousel = [
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w1.png",
    label: (
      <ImageContainer
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w1.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w2.png",
    label: (
      <ImageContainer
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w2.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w3.png",
    label: (
      <ImageContainer
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w3.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w4.png",
    label: (
      <ImageContainer
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w4.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w5.png",
    label: (
      <ImageContainer
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w5.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w6.png",
    label: (
      <ImageContainer
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w6.png"}
      />
    ),
  },
];

export const backgorundImagesVideoCorouselVudio = [
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w1.png",
    label: (
      <ImageContainerVudio
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w1.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w2.png",
    label: (
      <ImageContainerVudio
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w2.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w3.png",
    label: (
      <ImageContainerVudio
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w3.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w4.png",
    label: (
      <ImageContainerVudio
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w4.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w5.png",
    label: (
      <ImageContainerVudio
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w5.png"}
      />
    ),
  },
  {
    value: "https://call-plugin-images.s3.ap-south-1.amazonaws.com/w6.png",
    label: (
      <ImageContainerVudio
        url={"https://call-plugin-images.s3.ap-south-1.amazonaws.com/w6.png"}
      />
    ),
  },
];

export const onPanelChange = (keys, expandPanel, setExpandPanel) => {
  const changedKeys = keys.filter((key) => !expandPanel.includes(key));
  const newExpandedPanels = [...changedKeys];
  setExpandPanel(newExpandedPanels);
};

export const handleChangePanel = (key, setExpandPanel) => {
  setExpandPanel([String(Number(key) + 1)]);
};

export const sfHomeFeedHeaderFontSizeOptions = [
  {
    value: "20px",
    label: "20px",
  },
  {
    value: "21px",
    label: "21px",
  },
  {
    value: "22px",
    label: "22px",
  },
  {
    value: "23px",
    label: "23px",
  },
  {
    value: "24px",
    label: "24px",
  },
  {
    value: "25px",
    label: "25px",
  },
  {
    value: "26px",
    label: "26px",
  },
  {
    value: "27px",
    label: "27px",
  },
  {
    value: "28px",
    label: "28px",
  },
  {
    value: "29px",
    label: "29px",
  },
  {
    value: "30px",
    label: "30px",
  },
  {
    value: "31px",
    label: "31px",
  },
  {
    value: "32px",
    label: "32px",
  },
];

export const borderRadiusOptions = [
  {
    value: "0px",
    label: "0px",
  },
  {
    value: "1px",
    label: "1px",
  },
  {
    value: "2px",
    label: "2px",
  },
  {
    value: "3px",
    label: "3px",
  },
  {
    value: "4px",
    label: "4px",
  },
  {
    value: "5px",
    label: "5px",
  },
  {
    value: "6px",
    label: "6px",
  },
  {
    value: "7px",
    label: "7px",
  },
  {
    value: "8px",
    label: "8px",
  },
  {
    value: "9px",
    label: "9px",
  },
  {
    value: "10px",
    label: "10px",
  },
  {
    value: "11px",
    label: "11px",
  },
  {
    value: "12px",
    label: "12px",
  },
];

export const PlacementOptions = [
  {
    value: "bottom-left",
    label: "Bottom Left",
  },
  {
    value: "bottom-center",
    label: "Bottom Center",
  },
  {
    value: "bottom-right",
    label: "Bottom Right",
  },
];

export const AspectRatioOptions = [
  {
    value: "9:16",
    label: "9:16",
  },
  {
    value: "16:9",
    label: "16:9",
  },
  {
    value: "1:1",
    label: "1:1",
  },
];
